export const LANGUAGE_ENG = 'LANGUAGE_ENG';
export const LANGUAGE_BAG = 'LANGUAGE_BAG';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
